import pimg1 from '../images/project/img-1.jpg'
import pimg2 from '../images/project/img-2.jpg'
import pimg3 from '../images/project/img-3.jpg'
import pimg4 from '../images/project/img-4.jpg'
import pimg5 from '../images/project/img-5.jpg'
import pimg6 from '../images/project/img-6.jpg'
import pimg7 from '../images/project/img-7.jpg'

import ps1img1 from '../images/project-single/img-1.jpg'
import ps1img2 from '../images/project-single/img-2.jpg'
import ps1img3 from '../images/project-single/img-3.jpg'
import ps1img4 from '../images/project-single/img-4.jpg'
import ps1img5 from '../images/project-single/img-5.jpg'
import ps1img6 from '../images/project-single/img-6.jpg'
import ps1img7 from '../images/project-single/img-7.jpg'

import psub1img1 from '../images/project-single/p1.jpg'
import psub1img2 from '../images/project-single/p2.jpg'


const Projects = [
    {
       Id:'1',
       pImg:pimg1,
       ps1img:ps1img1,
       psub1img1:psub1img1,
       psub1img2:psub1img2,
       title:'Modern, Interactive & Engaging Design',  
       subTitle:'Laser Gun Gaming Website',  
       description:'This project was built with a dynamic and responsive layout, offering gamers an immersive experience. The website highlights game features, smooth navigation, and a bold design that captures the excitement of laser gun gaming.' 
    },
    {
       Id:'2',
       pImg:pimg2,
       ps1img:ps1img2,
       psub1img1:psub1img1,
       psub1img2:psub1img2,
       title:'Flooring Company Website', 
       subTitle:'Clean & SEO-Friendly Design',  
       description:'This website was designed to showcase flooring services with a modern and professional layout. It features clear service sections, easy navigation, and SEO-optimized content, helping the company attract more local clients and build trust online.'  
    },
    {
      Id:'3',
      pImg:pimg3,
      ps1img:ps1img3,
      psub1img1:psub1img1,
      psub1img2:psub1img2,
      title:'Painting Services Website',  
      subTitle:'Clean, Elegant & Easy to Use',  
      description:'This website was created for a painting services company with a bright and engaging layout. It highlights services, showcases past projects, and provides easy contact options, making it simple for customers to explore and request painting solutions.' 
   },
   {
      Id:'4',
      pImg:pimg4,
      ps1img:ps1img4,
      psub1img1:psub1img1,
      psub1img2:psub1img2,
      title:'App Design With Maintaining UI/UX Process.', 
      subTitle:'Web Design',    
   },
   {
      Id:'5',
      pImg:pimg5,
      ps1img:ps1img5,
      psub1img1:psub1img1,
      psub1img2:psub1img2,
      title:'Architecture & Interior Website Design', 
      subTitle:'Website / Creative',    
   },
   {
      Id:'6',
      pImg:pimg6,
      ps1img:ps1img6,
      psub1img1:psub1img1,
      psub1img2:psub1img2,
      title:'Restaurant and Food App Design.', 
      subTitle:'App Design',    
   },
   {
      Id:'7',
      pImg:pimg7,
      ps1img:ps1img7,
      psub1img1:psub1img1,
      psub1img2:psub1img2,
      title:'Architecture & Interior Website Design', 
      subTitle:'Web Design',    
   },
   {
      Id:'8',
      pImg:pimg5,
      ps1img:ps1img5,
      psub1img1:psub1img1,
      psub1img2:psub1img2,
      title:'App Design and Development Process', 
      subTitle:'Web Design',    
   },
    
]

export default Projects;